import { mode } from '@chakra-ui/theme-tools';
var parts = ['container', 'title', 'description', 'icon'];

function baseStyleContainer(props) {
  var {
    orientation
  } = props;
  var isVert = orientation === 'vertical';
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 'base',
    height: isVert ? '200px' : 'auto',
    textAlign: isVert ? 'center' : 'left',
    flexDirection: isVert ? 'column' : 'row',
    justifyContent: isVert ? 'center' : 'flex-start'
  };
}

function baseStyleTitle(props) {
  var {
    orientation
  } = props;
  var isVert = orientation === 'vertical';
  return {
    mt: isVert ? 4 : 0,
    mr: isVert ? 0 : 2,
    maxWidth: isVert ? 'sm' : 'md',
    color: 'black',
    fontWeight: 'bold',
    lineHeight: 6
  };
}

function baseStyleDescription(props) {
  var {
    orientation
  } = props;
  var isVert = orientation === 'vertical';
  return {
    mt: isVert ? 4 : 0,
    maxWidth: isVert ? 'sm' : 'unset',
    color: 'black',
    fontWeight: 'normal',
    lineHeight: 6
  };
}

function baseStyleIcon(props) {
  var {
    orientation
  } = props;
  var isVert = orientation === 'vertical';
  return {
    flexShrink: 0,
    mt: isVert ? 4 : 0,
    mr: isVert ? 0 : 2,
    w: isVert ? '72px' : 7,
    h: isVert ? '72px' : 6
  };
}

function variantSubtle(props) {
  var {
    color: c
  } = props;
  return {
    container: {
      bg: mode('white', 'whiteAlpha.700')(props),
      my: 3
    },
    icon: {
      color: c
    }
  };
}

function variantLeftAccent(props) {
  var {
    color: c
  } = props;
  return {
    container: {
      pl: 3,
      py: 3,
      borderLeft: 0,
      borderColor: 'none',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: 1,
        borderRadius: '10px 0 0 10px',
        bg: c
      },
      bg: mode('white', 'whiteAlpha.700')(props)
    },
    icon: {
      color: c
    }
  };
}

function variantLeftFilled(props) {
  var {
    borderColor,
    color: defaultBc
  } = props;
  var color = borderColor || defaultBc;
  return {
    container: {
      border: '1px solid',
      borderColor: color,
      overflow: 'unset',
      pl: 6,
      py: 3,
      bg: mode('white', 'whiteAlpha.700')(props),
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-1px',
        bottom: 0,
        width: '66px',
        borderRadius: '8px 0 0 8px',
        bg: color
      }
    },
    icon: {
      color: color,
      h: '2.5rem',
      w: '2.5rem',
      mr: 4,
      position: 'relative',
      left: -3
    }
  };
}

function variantOutline(props) {
  var {
    color: c
  } = props;
  return {
    container: {
      bg: mode('white', 'whiteAlpha.700')(props),
      border: '1px solid',
      borderColor: c,
      px: 4,
      py: 3
    },
    icon: {
      color: c
    }
  };
}

var variants = {
  subtle: variantSubtle,
  'left-accent': variantLeftAccent,
  'left-filled': variantLeftFilled,
  outline: variantOutline
};
var defaultProps = {
  variant: 'subtle',
  orientation: 'horizontal'
};

var baseStyle = props => ({
  container: baseStyleContainer(props),
  title: baseStyleTitle(props),
  description: baseStyleDescription(props),
  icon: baseStyleIcon(props)
});

export default {
  parts,
  baseStyle,
  variants,
  defaultProps
};
//# sourceMappingURL=Alert.js.map